import {ajaxAsync} from "./ajaxAsync";
import qs from 'qs';
import {encryptJson} from '../utils/encryptJson'
import axiosService from './axiosService'
import {getCookie} from '../globalFunction'

export default (options) => {
    // 发送前设置请求头，对数据进行加密
    let arr = ['api-v3-ipv6', 'nodes.speedtest.cn','nodes-api.speedtest.cn']
    if (arr.some(item => {
        return options.url.includes(item)
    })) {
        if (options.reqType === 'axios' || !options.reqType) {
            return axiosService(options)
        } else if (options.reqType === 'ajax') {
            return ajaxAsync(options)
        }
    }
    if (options.headers) {
        options.headers.ENCRYPT = true
    } else {
        options.headers = {
            ENCRYPT: true
        }
    }
    if (getCookie('token')) {
        options.headers.Authorization = "Bearer " + getCookie('token');
    }
    // 判断发送类型
    if (!options.method || options.method.toLowerCase() === 'get') {
        options.method = 'get'
    }
    // 设置携带参数
    let datas = (options.params || options.data)
    if (options.queryType !== 'file' && datas) {
        if (options.method === 'get') {
            options.params = {data: encryptJson(datas)}
            options.data = null
        } else {
            options.data = qs.stringify({data: encryptJson(datas)})
            options.params = null
        }
    } else {
        options.data = datas;
    }
    if (options.reqType === 'axios' || !options.reqType) {
        return axiosService(options)
    } else if (options.reqType === 'ajax') {
        return ajaxAsync(options)
    }
}



// WEBPACK FOOTER //
// ./resources/js/config/request.js